<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  .settings-page {
    display: flex;
    flex-direction: column;
    padding: utils.in_rem(4px) 0;
    gap: utils.in_rem(24px);
    align-self: stretch;
    align-items: flex-start;
    .title {
      @include mixins.h2();
      @include colors.color(primary_50);
    }

    &.skeleton {
      height: utils.in_rem(450px);
      @include colors.background-color(interfaceTransparentBlack_1);
      @include mixins.skeleton;
    }
  }
</style>

<script>
  import {
    teamNotetakerSettingsStore,
    teamStore,
  } from "../../../api-stores/meetings-store";
  import AutoJoinSettings from "./Notetaker/AutoJoinSettings.svelte";
  import BotCustomizationSettings from "./Notetaker/BotCustomizationSettings.svelte";
  import LanguageSettings from "./Notetaker/LanguageSettings.svelte";

  teamStore.once(); // Ensure teamStore is initialized
</script>

{#if !$teamNotetakerSettingsStore}
  <div class="settings-page skeleton"></div>
{:else}
  <div class="settings-page">
    <span class="title">Notetaker Settings</span>
    <BotCustomizationSettings />
    <AutoJoinSettings />
    <LanguageSettings />
  </div>
{/if}
